module.exports = __webpack_public_path__ + "static/img/Ox.f859902.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/cz_animal/Ox.svg
// module id = 1363
// module chunks = 0